var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 15a1 1 0 110 2H4.66l-2.143 5h18.966l-2.142-5h-1.34a1 1 0 110-2h2c.4 0 .761.238.918.606l3 7A.997.997 0 0123 24H1a1.001 1.001 0 01-.919-1.394l3-7a.999.999 0 01.92-.606h2zm6-14c3.86 0 7 3.073 7 6.85 0 5.56-6.1 10.702-6.36 10.919a1 1 0 01-1.28 0C11.101 18.552 5 13.41 5 7.85 5 4.073 8.141 1 12 1zm0 2C9.243 3 7 5.175 7 7.85c0 3.669 3.522 7.398 5 8.801 1.478-1.403 5-5.132 5-8.801C17 5.175 14.757 3 12 3zm0 3c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2z",
    fill: "#222",
    fillRule: "evenodd",
    className: "fi-icon-base-fill"
  })));
}

export default SvgIconMap;